// Imports
import ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/noSourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, "\n.card[data-v-5d2654c2]{\n\tmax-height:100%;\n}\n.date[data-v-5d2654c2] {\n\tdisplay: inline-block;\n\tfont-size: 13px;\n\tcolor: var(--main-gray-4);\n\twidth: 100%;\n}\n\n", ""]);
// Exports
export default ___CSS_LOADER_EXPORT___;
